import React, { FC } from "react";
import cn from "classnames";
import { MinMaxValues } from "src/@types/filtering";
import { ReactComponent as CloseIcon } from "src/assets/icons/close.svg";
import { Filtering } from ".";

interface Props {
  className?: string;
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  filtersValues: MinMaxValues;
  pagePath?: string;
}

export const MobFilteringMenu: FC<Props> = ({
  isOpen,
  setIsOpen,
  filtersValues,
  pagePath,
  className,
}) => {
  const onClose = () => setIsOpen(false);

  return (
    <div
      className={cn(
        "absolute top-19 left-0 w-full min-h-screen bg-white-pink z-50 transition-transform duration-300",
        className,
        {
          "transform translate-x-0": isOpen,
          "transform -translate-x-full": !isOpen,
        }
      )}
    >
      <div className="flex flex-col items-center mt-10">
        <button
          className="absolute top-4 right-5 hover:scale-125"
          onClick={onClose}
        >
          <CloseIcon />
        </button>

        <Filtering filtersValues={filtersValues} pagePath={pagePath} />
      </div>
    </div>
  );
};
